export const userInputs = [
    {
      id: "displayName",
      label: "Nom complet",
      type: "text",
      placeholder: "",
    },
    {
      id: "email",
      label: "Email",
      type: "mail",
      placeholder: "",
    },
    {
      id: "phone",
      label: "Téléphone",
      type: "text",
      placeholder: "+237 ... ... ...",
    },
    {
      id: "password",
      label: "Mot de passe",
      type: "text",
    },
    {
      id: "city",
      label: "Ville",
      type: "text",
      placeholder: "Yaoundé",
    },
    {
      id: "country",
      label: "Pays",
      type: "text",
      placeholder: "Cameroun",
    },
  ];
  
  export const productInputs = [
    {
      id: 1,
      label: "Title",
      type: "text",
      placeholder: "Apple Macbook Pro",
    },
    {
      id: 2,
      label: "Description",
      type: "text",
      placeholder: "Description",
    },
    {
      id: 3,
      label: "Category",
      type: "text",
      placeholder: "Computers",
    },
    {
      id: 4,
      label: "Price",
      type: "text",
      placeholder: "100",
    },
    {
      id: 5,
      label: "Stock",
      type: "text",
      placeholder: "in stock",
    },
  ];
  